// =============================================================================
// state
// =============================================================================
const state = {
  historys: [],
};
// =============================================================================
// getters
// =============================================================================
const getters = {
  historys: state => state.historys,
};
// =============================================================================
// actions
// =============================================================================
const actions = {
};
// =============================================================================
// mutations
// =============================================================================
const mutations = {
  set_data (state, value) {
    state.historys = value.historys;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
